function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { UnlockFilled } from "@ant-design/icons";
import { Button, Input, List, Drawer, Avatar, Space, Image, Card } from "antd";
import UserLogin from "./forms/UserLogin";
import { PersonLinesFill, HouseFill, FilePostFill, QuestionCircleFill, Activity, Globe2, SaveFill, Twitter, Facebook, Whatsapp } from 'react-bootstrap-icons';
import Start from "./forms/Start";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Meta = Card.Meta;
var Search = Input.Search;
var HomeContent = function HomeContent() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    drawerVisible = _useState2[0],
    setDrawerVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    connectVisible = _useState4[0],
    setConnectVisible = _useState4[1];
  var inputRef = useRef(null);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "home-page-heroe",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: {
              span: 5
            },
            md: {
              span: 5
            },
            sm: 12,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                borderRadius: "8px",
                backgroundColor: "#FAFAFA",
                backgroundImage: "url(drawables/cl-heroe.jpg)",
                backgroundSize: "270px auto",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right",
                boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px"
              },
              children: /*#__PURE__*/_jsx(UserLogin, {
                ref: inputRef,
                id: "log"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: {
              span: 7
            },
            md: {
              span: 7
            },
            sm: 12,
            children: /*#__PURE__*/_jsxs("div", {
              className: "home-page-heroe-title",
              children: [/*#__PURE__*/_jsx("b", {
                style: {
                  color: "#A04707"
                },
                children: "CLINIQUEADMIN"
              }), /*#__PURE__*/_jsx("h1", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Gerez votre structure de sant\xE9 dans le CLOUD avec un logiciel intuitif et s\xE9curis\xE9"
                })
              }), /*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: function onClick() {
                  setDrawerVisible(true);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "Commencer"
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("b", {
                children: ["Vous avez d\xE9j\xE0 un compte ? ", /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    var _document$getElementB, _inputRef$current;
                    (_document$getElementB = document.getElementById("log")) === null || _document$getElementB === void 0 || _document$getElementB.scrollIntoView({
                      behavior: "smooth"
                    });
                    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Entrez vos identifiants pour acc\xE9der \xE0 votre compte"
                  })
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Button, {
                  type: "default",
                  size: "large",
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(Facebook, {
                      size: 30
                    })
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "default",
                  size: "large",
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(Whatsapp, {
                      size: 30
                    })
                  })
                })]
              })]
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            actions: [],
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m1.jpeg"
            }),
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Identification de vos patients"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            actions: [],
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m2.jpeg"
            }),
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Gestion du laboratoire biochimique",
              x: true
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            actions: [],
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m3.jpeg"
            }),
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Comptes rendu de consultations"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            actions: [],
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m6.jpg"
            }),
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Gestion des unit\xE9s d'imagerie"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m5.jpeg"
            }),
            actions: [],
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Gestion de service d'ophtalmologie"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 2,
          children: /*#__PURE__*/_jsx(Card, {
            hoverable: true,
            style: {},
            cover: /*#__PURE__*/_jsx("img", {
              alt: "example",
              src: "/drawables/m4.jpeg"
            }),
            actions: [],
            children: /*#__PURE__*/_jsx(Meta, {
              description: "Gerer vos factures, clients, patients"
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "Commencer ... !"
      }),
      width: "100%",
      onClose: function onClose() {
        setDrawerVisible(false);
      },
      destroyOnClose: false,
      open: drawerVisible,
      children: /*#__PURE__*/_jsx(Start, {})
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["Se connecter \xE0 ", /*#__PURE__*/_jsx(UnlockFilled, {}), " CliniqueAdmin"]
      }),
      headerStyle: {
        background: "#F2F1E7"
      },
      height: "350px",
      onClose: function onClose() {
        setConnectVisible(false);
      },
      destroyOnClose: false,
      placement: "top",
      open: connectVisible,
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 5,
          sm: 8,
          children: /*#__PURE__*/_jsx(UserLogin, {})
        }), /*#__PURE__*/_jsx(Col, {})]
      })
    })]
  });
};
export default HomeContent;